// Dates et pluriels du lecteur, en natif (Intl) : aucun paquet, aucun texte changé.
// Toute date invalide rend '' au lieu de « Invalid Date » / NaN.

const LOCALE = 'fr-FR';
const REGLE = new Intl.PluralRules(LOCALE);
const FORMATS = new Map();

const valide = (date) => {
  if (date == null || date === '') return null;
  const d = new Date(date);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** Date formatée en français ; `options` absent = format court du navigateur (jj/mm/aaaa). */
export function dateFr(date, options, heure = false) {
  const d = valide(date);
  if (!d) return '';
  const cle = `${heure}${JSON.stringify(options ?? null)}`;
  let f = FORMATS.get(cle);
  if (!f) {
    f = new Intl.DateTimeFormat(LOCALE, options ?? (heure ? { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' } : undefined));
    FORMATS.set(cle, f);
  }
  return f.format(d);
}

/** Année d'une date, ou null si elle est invalide. */
export function anneeDe(date) {
  return valide(date)?.getFullYear() ?? null;
}

/** Jours calendaires locaux avant une date (minuit contre minuit), null si passée/aujourd'hui/invalide. */
export function joursAvant(date, maintenant = Date.now()) {
  const d = valide(date);
  if (!d) return null;
  const n = new Date(maintenant);
  const jour = (x) => Date.UTC(x.getFullYear(), x.getMonth(), x.getDate()) / 86_400_000;
  const reste = jour(d) - jour(n);
  return reste > 0 ? reste : null;
}

/** « 1 jour », « 2 jours » : forme choisie par la règle de pluriel du français. */
export function pluriel(n, singulier, plurielForme = `${singulier}s`) {
  return REGLE.select(n) === 'one' ? singulier : plurielForme;
}
